import React from 'react';
import Button from "@material-ui/core/Button/Button";
import { useNavigate } from "react-router-dom";
import { reactGaEvent } from "examsbook-react-sdk/actions/Common";
import { useQuizButtonStatus } from "examsbook-react-sdk/custom-hooks";

/**
 * QuizCardButtons component.
 * @param props
 * @returns {*}
 * @constructor
 */
const QuizCardButtons = props => {
    const { quizData } = props;
    const navigate = useNavigate();
    const { disabled, label, action } = useQuizButtonStatus(quizData);

    function handleClickAction() {
        if (action === 'PAYMENT') {
            //open payment popup and make payment.
            navigate("/my-app/payments");
        } else if (action) {
            navigate((action === 'START') ? '/my-app/quiz/' + quizData.mode + '/' + quizData.slug : '/my-app/tests/result/' + quizData._id);
            reactGaEvent("Live Test", "Start Quiz");
        }
    }

    return (
        <div className="card-btn">
            <Button onClick={handleClickAction} disabled={disabled}>
                {label}
            </Button>
        </div>
    );
};

export default QuizCardButtons;
